export default __webpack_public_path__ + "static/media/subscribe-button-img.08368bc9.svg";